module.exports = __webpack_public_path__ + "static/media/stjernekolonien-logo.da6ff253.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePage/static/stjernekolonien-logo.svg
// module id = 150
// module chunks = 0